import React, { useState, useEffect } from "react";
import classes from "./styles/style.module.css";
import PreMatchImg from "../../../assets/images/joftPooch/preMatchImg.png";
import Statistics from "./Statistics";
import PreDesc from "./PreDesc";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import Preview from "./Preview";
import MatchMenuElement from "../../../assets/components/Match/MenuElment";
import { menuItems } from "../dashboard/MatchDashboardMenu/menuItems";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import StartMatchAlert from "../alertContents/StartMatchAlert";
import QuizRequests from "../../../assets/services/quiz";
import {
  setfinalizeQuiz,
  setfinalizeReport,
  setAnsweredQuestoinsCount,
  setQuestionAnswer,
  setLastQuestionId,
  setMaxAnswer,
  setShowFinalizeModal,
  setShowCheatModal,
} from "../../../assets/redux/actions/Quiz";
import appApi from "../../../assets/utils/AppApi";
import Skeleton from "@mui/material/Skeleton";

const PreMatch = () => {
  const item = menuItems[0];
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quiz, setQuiz] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getQuiz();
  }, []);

  const getQuiz = () => {
    setLoading(true);
    appApi
      .get(`/quiz/getsingle/${id}`)
      .then(({ data }) => {
        setQuiz(data.quiz);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleStartMatch = async () => {
    dispatch(setShowCheatModal(false));
    dispatch(setfinalizeQuiz(false));
    dispatch(setfinalizeReport(null));
    dispatch(setAnsweredQuestoinsCount(null));
    dispatch(setQuestionAnswer(null));
    dispatch(setLastQuestionId(""));
    dispatch(setMaxAnswer(0));
    dispatch(setShowFinalizeModal(false));
    try {
      const ticket = await dispatch(QuizRequests.startQuiz(id));
      localStorage.removeItem("Ticket");
      localStorage.setItem("Ticket", ticket._id);
      if (ticket.lastQuestionId !== null) {
        dispatch(setLastQuestionId(ticket.lastQuestionId));
        navigate(`/questions/${id}`);
      } else {
        dispatch(setLastQuestionId(""));
        navigate(`/questions/${id}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <img
          src={PreMatchImg}
          alt="preMatchImg"
          className={classes.preMatchImg}
          height={"111px"}
        />
        {quiz && (
          <>
            <Statistics
              maxAnswer={quiz.maxAnswer}
              duration={quiz.quizDuration}
              questionCount={"_"}
            />
            <PreDesc name={quiz.title} desc={quiz.description} />
          </>
        )}

        {loading && (
          <>
            <Skeleton
              variant="rectangular"
              width={"100%"}
              height={97}
              sx={{ marginBottom: "48px" }}
            />
            <Skeleton height={48} width={200} />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </>
        )}
        <Preview matchId={id} />
        <div className="w-100 mb-5">
          <MatchMenuElement
            elementInfo={item}
            fullWidth={item.width === "full"}
            disable={item.disable}
            showNew={item.showNew}
            handleClick={() => setShowDialog(true)}
          />
        </div>
      </div>
      <StartMatchAlert
        show={showDialog}
        startMatch={handleStartMatch}
        handleClose={() => setShowDialog(false)}
      />
    </AnimatedPageContainer>
  );
};

export default PreMatch;
